import {IFrame} from '@mintdata/mint-kit/api/values/frames/Frame';
import {FrameQueryResult} from '@mintdata/mint-kit/impl/frames/FrameQueryResult';
import {FrameSelectionEngine} from '@mintdata/mint-kit/impl/frames/FrameSelectionEngine';
import {FrameSelectExpr} from '@mintdata/mint-kit/impl/frames/FrameSelectorTypes';

export class FrameSelector
{
    public static readonly EXPR_PREFIX = '@';

    private static _engine:FrameSelectionEngine = null;

    private static _getEngine():FrameSelectionEngine
    {
        FrameSelector._engine = FrameSelector._engine || new FrameSelectionEngine();

        return FrameSelector._engine;
    }

    public static select(frame:IFrame, frameSelectExpr:FrameSelectExpr):IFrame
    {
        return FrameSelector._getEngine().select(frame, frameSelectExpr);
    }

    public static query(frame:IFrame, frameSelectExpr:FrameSelectExpr):FrameQueryResult
    {
        return FrameSelector._getEngine().query(frame, frameSelectExpr);
    }

    public static expressionFromQueryResult(fqr:FrameQueryResult):FrameSelectExpr
    {
        return FrameSelector._getEngine().expressionFromQueryResult(fqr);
    }
}
